import React, {useEffect, useState} from 'react';
import Frame from "../components/layout/Frame";
import {Card, Col, Row} from "react-bootstrap";
import Container from "react-bootstrap/Container";
import {getTrfATList} from "../api/apiClient";
import Moment from "moment";
import DateFacilitySearchBox from "../components/searchBoxs/DateFacilitySearchBox";
import TableAT from "../components/tables/TableAT";

const TrafAbnormal = () => {

  /* pagination을 위한 state */
  const [listPageSize, setListPageSize] = useState(15);
  const [tableList, setTableList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);

  // 검색 조건
  let dtNow = new Date();
  let dtYesterday = new Date();
  dtYesterday.setDate(dtNow.getDate() - 1);
  const [searchParam, setSearchParam] = useState({
    startDate: dtYesterday,
    endDate: dtNow,
    searchFcltyNo: ''  // 시설명
  });
  // 검색 버튼 클릭했는지
  const [isSearch, setIsSearch] = useState(true);

  // 이상트래픽 발생 센서장비 현황
  const [cardsList, setCardsList] = useState([]);

  // 리스트 갱신
  const updateList = () => {
    // console.log(currentPage, listPageSize, searchParam);
    getTrfATList(currentPage, listPageSize,
        searchParam.searchFcltyNo,
        Moment(searchParam.startDate).format('YYYY-MM-DD'),
        Moment(searchParam.endDate).format('YYYY-MM-DD'),)
        .then(res => {
          console.log(res);
          if (res.data.data !== undefined) {
            setCardsList(res.data.data.cardsList)
            setTableList(res.data.data.statusList.list);
            setTotal(res.data.data.statusList.total);
          }
        });
  };

  useEffect(() => {
    setIsSearch(false);
  }, []);

  useEffect(() => {
    updateList();
  }, [isSearch, currentPage, listPageSize]);

  return (
      <Frame
          propIsActiveHeader={true}
          propIsActiveSidebar={true}
      >
        <Container fluid>
          <Row className={"p-3"}>
            <Col md={12} className={"search-container py-2"}>
              <DateFacilitySearchBox
                  searchParam={searchParam}
                  setSearchParam={setSearchParam}
                  updateList={updateList}
                  setCurrentPage={setCurrentPage}
              />
            </Col>
            <Col md={12} className={"content-container mt-3 py-2 mw-100"}>
              <h6 className={"text-center fw-normal my-3"}>이상트래픽 발생 현황</h6>
              <Row className={"justify-content-evenly text-center equipment-list my-2"}>
                {
                  Array.isArray(cardsList) ?
                      (cardsList.map((elem, idx) => {
                        return (
                            <Col key={idx} md={2} className={"equipment-item fire"}>
                              <Card border="light" bg={"dark"}>
                                <Card.Body>
                                  <Row>
                                    <Col>{elem.nm}</Col>
                                  </Row>
                                  <Row className={"mt-2"}>
                                    <Col>
                                      <span className={"occur"}>{elem.alarm_co}</span>
                                      <span className={"ms-1"}>건</span>
                                    </Col>
                                  </Row>
                                </Card.Body>
                              </Card>
                            </Col>
                        )
                      })) :
                      ''
                }
              </Row>
            </Col>
            <Col md={12} className={"table-container mt-3 py-2 mw-100"}>
              <TableAT
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  listPageSize={listPageSize}
                  setListPageSize={setListPageSize}
                  total={total}
                  tableList={tableList}
                  setIsSearch={setIsSearch}
                  searchParam={searchParam}
                  setSearchParam={setSearchParam}
                  updateList={updateList}
                  setTableList={setTableList}
                  setTotal={setTotal}
              />
            </Col>
          </Row>
        </Container>
      </Frame>
  );
};

export default TrafAbnormal;
